import { mapActions } from 'vuex';
import Routing from '../core/router/router';
import { HTTP } from '../core/http/http-common';

export default {
  methods: {
    ...mapActions(['setError', 'setErrorId']),

    addErrorToPlayer(data) {
      Object.keys(data).forEach(key => {
        if (!data[key]) {
          delete data[key];
        }
      });
      this.setError(data);

      HTTP.post(Routing.generate('api_media_add_error_player'), data)
        .then(response => {
          console.log('response ', response);
          this.setErrorId(response.data.id_error);
        })
        .catch(e => {
          console.log('error ', e);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/mixins.js